import { ArrowLeft, ArrowRight, Button, Heading } from '@core/ui';
import { t } from 'i18next';
import { Duration } from 'luxon';
import { useEffect, useState } from 'react';
import { Timeline, VideoLayoutTimelineEvent } from '../../../parser';
import { TimestampInput } from '../../molecules';

export const VideoLayoutEditorOrganism = ({
    timeline,
    currentTime,
    onSeek
}: {
    timeline: Timeline;
    currentTime: Duration;
    onSeek: (seek: Duration) => void;
}) => {
    const [previous, setPrevious] = useState<VideoLayoutTimelineEvent>();
    const [next, setNext] = useState<VideoLayoutTimelineEvent>();
    const [current, setCurrent] = useState<VideoLayoutTimelineEvent>();
    const [currentIndex, setCurrentIndex] = useState<number>(-1);

    useEffect(() => {
        if (!timeline) {
            setPrevious(undefined);
            setCurrent(undefined);
            setNext(undefined);
            return;
        }

        let prev: VideoLayoutTimelineEvent | undefined = undefined;
        let curr: VideoLayoutTimelineEvent | undefined = undefined;
        let currIndex: number = -1;
        let next: VideoLayoutTimelineEvent | undefined = undefined;
        for (let i = 0; i < timeline.videoLayouts.length; i++) {
            if (timeline.videoLayouts[i].timestamp <= currentTime) {
                if (i > 0) {
                    prev = timeline.videoLayouts[i - 1];
                }

                curr = timeline.videoLayouts[i];
                currIndex = i;

                if (i < timeline.videoLayouts.length - 1) {
                    next = timeline.videoLayouts[i + 1];
                }
            }
        }

        if (!curr && timeline.videoLayouts.length > 0) {
            next = timeline.videoLayouts[0];
        }

        setPrevious(prev);
        setCurrent(curr);
        setCurrentIndex(currIndex);
        setNext(next);
    }, [timeline, currentTime]);

    return (
        <div className="bg-gray-100 border border-gray-500 flex flex-col gap-4 pb-2">
            <div className="flex-1 flex flex-col bg-white rounded-b-webinarsub p-4">
                <div className="flex items-center justify-between gap-2 mb-4">
                    <Heading variant="h2">{t('Editor.VideoLayout.Heading')}</Heading>
                </div>
                <div className="flex-1 flex items-center justify-center gap-x-2">
                    <Button variant="primary" iconbtn onClick={() => onSeek(previous?.timestamp || Duration.fromMillis(0))} disabled={!previous}>
                        <span className="sr-only">{t('VideoLayout.Button.Previous')}</span>
                        <ArrowLeft classNames="size-6 fill-current" />
                    </Button>
                    {/** Misschien hier een wireframe image van de layout? */}
                    <Button variant="primary" iconbtn onClick={() => onSeek(next?.timestamp || Duration.fromMillis(0))} disabled={!next}>
                        <span className="sr-only">{t('VideoLayout.Button.Next')}</span>
                        <ArrowRight classNames="size-6 fill-current" />
                    </Button>
                </div>
            </div>
            {current && <TimestampInput timestamp={current.timestamp} onChange={(timestamp) => (current.timestamp = timestamp)} />}
        </div>
    );
};
